<template>
	<div class="sub_contents brand">
		<div class="cont_center">
			<div id="slide_box" v-if="currentTab == 0">
				<swiper :slidesPerView="3" :spaceBetween="30" :freeMode="true" :pagination="{
					clickable: true,
				}" :navigation="true" :autoplay="{
					delay: 3000,
					disableOnInteraction: false,
				}" :loop="true" :modules="modules" :breakpoints="{
					0: {
						slidesPerView: 1,
						spaceBetween: 10,
						loop: true,
					},
					480: {
						slidesPerView: 1,
						spaceBetween: 15,
						loop: true,
					},
					640: {
						slidesPerView: 2,
						spaceBetween: 20,
						loop: true,
					},
					1024: {
						slidesPerView: 3,
						spaceBetween: 30,
						loop: true,
					},
				}" class="mySwiper">
					<swiper-slide v-for="(item, index) in bannerPrList" :key="index">
						<a :href="'/HFO_BI_002/' + item.brandUuid" @click.prevent="routerLink(item.brandUuid)" rel="noopener noreferrer">
							<img :src="makeBrandImageUrl(item.brandPath)" :alt="item.brandName || '브랜드 배너'" @error="handleBannerHeroPcImageError"
								:loading="index === 0 ? 'eager' : 'lazy'" class="banner-slide-img" />
						</a>
					</swiper-slide>
				</swiper>
			</div>

			<SiteIntro heading :text="false" />
			<div class="brand_list_area">
				<TabArea :tab="tab" :currentTab="currentTab" :class="{ tab_col_3: isTabActive, tab_brand: isBrandTab }"
					@click="changeTab" />

				<div class="search_box_area">
					<div class="input_area notice">
						<div class="check_area">
							<CheckBox v-for="option in checkOptions" :key="option.value" :id="option.value"
								:value="option.value" :label="option.label" v-model="selectedOptions"
								@change="handleOptionChange" />
						</div>

						<transition name="fade">
							<InputText :placeholder="placeholderSearch" v-model="brandNameInput"
								@input="updateBrandName" @keyup.enter="search" />
						</transition>
						<button type="button" class="btn_search" @click="search">
							검색
						</button>
					</div>
				</div>

				<div class="tab_contents">
					<ul class="brand_list">
						<transition-group name="list-fade">
							<li :key="item.brandUuid" v-for="item in brandList" class="brand-card">
								<!-- 청구할인 마크 위치 고정 -->
								<div class="discount-badge">
									<p class="discout_percent" :class="{ 'special-discount': isAllCardStatusN(item) }">
										<template v-if="isAllCardStatusN(item)">
											<span class="special_discount_text">
												<span>특별</span>
												<span>할인</span>
											</span>
										</template>
										<template v-else>
											청구할인<br />
											<strong>{{ item.benefit }}%</strong>
										</template>
									</p>
								</div>

								<!-- 온라인 표시를 a 태그 밖으로 이동 -->
								<p class="online" v-if="item.brandType === 'BRAND_ONLINE'">ONLINE</p>

								<a :href="'/HFO_BI_002/' + item.brandUuid" @click.prevent="routerLink(item.brandUuid)" class="card-content">
									<!-- 이미지 영역 -->
									<div class="brand-image-area">
										<img :src="makeBrandImageUrl(item.logoPath)" alt="" loading="lazy"
											@error="handleBrandImageError" />
									</div>

									<!-- 브랜드 정보 영역 -->
									<div class="brand_info_area">
										<p class="brand_name">{{ item.brandName }}</p>
										<p class="brand_info_txt" v-html="item.brandRmks">
										</p>
									</div>
								</a>
							</li>
						</transition-group>
					</ul>
				</div>
			</div>

			<div class="btn_view_brand" v-if="hasMoreBrands">
				<button type="button" @click="fetchMore">브랜드 보기</button>
			</div>
		</div>
	</div>
</template>

<script>
import { ref, watch, onMounted, onUnmounted, nextTick, getCurrentInstance } from "vue";
import { onBeforeRouteLeave } from "vue-router"; // vue-router에서 임포트
import InputText from "@/components/InputText";
import TabArea from "@/components/TabArea";
import { getBranchUuid, getBrandServiceType } from "@/lib/Config";
import { useQuery } from "@tanstack/vue-query";
import { getAxios, getAxiosDirect } from "@/lib/AxiosCall";
import { DEFAULT_NO_IMAGE } from "@/lib/Constant";
import { useRouter } from "vue-router";
import CheckBox from "@/components/CheckBox";

// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from "swiper/vue";

// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/autoplay";

// import required modules
import { FreeMode, Pagination, Navigation, Autoplay } from "swiper/modules";

export default {
	name: "HFO_BI_001",
	components: {
		InputText,
		TabArea,
		Swiper,
		SwiperSlide,
		CheckBox,
	},
	// ① savedScroll 초기값 추가
	data() {
		return {
			currentTab: 0,
			selectedOptions: ["1"],
			checkOptions: [
				{
					label: "전체",
					value: "1",
				},
				{
					label: "온라인",
					value: "2",
				},
				{
					label: "오프라인",
					value: "3",
				},
			],
			savedScroll: 0, // ← 여기 추가
		};
	},

	beforeUnmount() {
		window.removeEventListener("scroll", this.updateSavedScroll);
	},
	// 언마운트되지 않고 비활성화될 때 호출
	deactivated() {
		// still capture one final time if you like
		this.savedScroll = window.scrollY;
	},
	// 다시 활성화될 때 호출
	activated() {
		// keep-alive로 다시 활성화될 때 스크롤 복원
		this.$nextTick(() => {
			const savedScroll = sessionStorage.getItem("brandListScroll");
			if (savedScroll) {
				this.savedScroll = parseInt(savedScroll, 10) || 0;
				sessionStorage.removeItem("brandListScroll");
			}

			// 저장된 스크롤 위치로 복원
			window.scrollTo(0, this.savedScroll);
		});
	},
	setup() {
		const router = useRouter();
		const branchUuid = getBranchUuid();
		const brandNameInput = ref('');

		// data()에 있는 값들을 ref로 가져오기
		const currentTabRef = ref(0);
		const selectedOptionsRef = ref(["1"]);

		// 인스턴스 참조를 setup 시작 부분에서 저장
		const instance = getCurrentInstance();

		// 페이지 떠나기 전에 상태 저장
		onBeforeRouteLeave((to) => {
			// HFO_BI_002로 이동하는 경우에만 상태 저장
			if (to.name === 'HFO_BI_002' || to.path.includes('HFO_BI_002')) {
				// 검색어 저장
				sessionStorage.setItem('brandNameInput', brandNameInput.value || '');

				// 현재 페이지 번호 저장
				sessionStorage.setItem('brandCurrentPage', currentPage.value.toString());

				// 선택된 필터 옵션 저장
				sessionStorage.setItem('brandSelectedOptions', JSON.stringify(selectedOptionsRef.value));

				// 현재 선택된 탭 저장
				sessionStorage.setItem('selectedCategoryTab', currentTabRef.value.toString());
				sessionStorage.setItem('selectedServiceType', brandReqData.value.brandServiceType);
			}
			// 메인 메뉴나 다른 주요 메뉴로 이동할 때는 카테고리 선택 정보 삭제
			else if (
				to.name === 'HFO_MA_001' ||      // 메인 페이지
				to.path.includes('/HFO_MA_') ||  // 메인 관련 페이지
				to.path === '/' ||               // 루트 페이지
				!to.path.includes('/HFO_BI_')    // BI_ 시리즈가 아닌 다른 페이지
			) {
				console.log("다른 메뉴로 이동: 카테고리 선택 상태 초기화");
				sessionStorage.removeItem('selectedCategoryTab');
				sessionStorage.removeItem('selectedServiceType');
			}
		});

		// 상태를 data()와 동기화하는 함수
		const syncWithData = (vm) => {
			if (!vm) return; // vm이 없으면 아무것도 하지 않음

			// data 값들을 ref에 동기화
			currentTabRef.value = vm.currentTab;
			selectedOptionsRef.value = vm.selectedOptions;

			// options API의 값 변경을 감시
			watch(() => vm.currentTab, (newVal) => {
				currentTabRef.value = newVal;
			});

			watch(() => vm.selectedOptions, (newVal) => {
				selectedOptionsRef.value = newVal;
			});
		};

		// 컴포넌트 마운트 시 동기화 실행 - 비동기 콜백에서 저장된 인스턴스 사용
		onMounted(() => {
			if (instance && instance.proxy) {
				// instance 변수 사용
				syncWithData(instance.proxy);
			} else {
				console.warn("컴포넌트 인스턴스를 찾을 수 없습니다.");
			}
		});

		// tab
		const tab = ref([{ name: "전체" }]);
		const brandServiceType = getBrandServiceType() || [];
		const brandServiceTypeTab = (Array.isArray(brandServiceType) ? brandServiceType : []).map((item, index) => ({
			name: item.cdValue,
			cd: item.cd,
			className: `icon${index + 2}`,
		}));

		tab.value = [{ name: "전체", cd: "" }, ...brandServiceTypeTab];

		// brand
		const brandList = ref([]);
		// 플레이스 홀더 로테이션 데이터
		const brandValue = ref([]);
		const placeholderSearch = ref("브랜드명을 입력하세요.");
		const currentPage = ref(1);
		const pageSize = ref(10);
		const hasMoreBrands = ref(true); // 더보기 버튼 표시 여부

		const brandReqData = ref({
			page: currentPage.value,
			size: pageSize.value,
			branchUuid: branchUuid,
			brandServiceType: "",
			brandName: "",
			brandType: "", // 브랜드 타입 필드 추가
		});

		const brandData = useQuery({
			queryKey: ["get-branch-brand", new Date().getTime(), brandReqData.value],
			queryFn: () => getAxiosDirect("/hvm/v1/branch/brand", brandReqData.value),
			enabled: false,
		});

		watch(
			() => brandData.data.value,
			(newData) => {
				if (newData && newData.page && newData.page.list) {
					// currentPage가 1 이면 새롭게, 아니면 concat
					brandList.value =
						currentPage.value === 1
							? newData.page.list
							: [...brandList.value, ...newData.page.list];

					// 브랜드 이름 저장
					brandValue.value = newData.page.brands;

					// 더보기 버튼 표시 여부
					hasMoreBrands.value = brandList.value.length < newData.page.total;
				}
			}
		);

		const isTabActive = ref(true);
		const isBrandTab = ref(true);

		brandData.refetch();

		let _placeholderTimer;
		onMounted(() => {
			let index = 0;
			_placeholderTimer = setInterval(() => {
				const names = Array.isArray(brandValue.value) ? brandValue.value : [];
				if (!names.length) {
					placeholderSearch.value = "브랜드명을 입력하세요.";
					return;
				}
				placeholderSearch.value = `${names[index]}을(를) 검색해보세요.`;
				index = (index + 1) % names.length;
			}, 3000);
		});
		onUnmounted(() => {
			if (_placeholderTimer) clearInterval(_placeholderTimer);
		});

		// brand
		const bannerPrList = ref([]);
		const bannerPrData = useQuery({
			queryKey: ["get-branch-banner-main", new Date().getTime(), branchUuid], // branchUuid 포함
			queryFn: () => getAxiosDirect("/hvm/v1/branch/brand/pr", { branchUuid }), // branchUuid 추가
		});

		watch(
			() => bannerPrData.data.value,
			(newData) => {
				if (newData && newData.page.list) {
					bannerPrList.value = newData.page.list;
				}
			}
		);

		// 검색 전용 데이터 객체 추가
		const isSearchMode = ref(false); // 검색 모드 여부
		const searchKeyword = ref(""); // 검색 키워드
		const searchResults = ref([]); // 검색 결과

		// 검색 API 요청 데이터
		const searchReqData = ref({
			page: 1,
			size: pageSize.value,
			branchUuid: branchUuid,
			keyword: "", // API는 brandName 대신 keyword 필드 사용
		});

		// 검색 API 쿼리 설정
		const searchData = useQuery({
			queryKey: ["get-branch-brand-search", new Date().getTime(), searchReqData],
			queryFn: () => getAxios("/hvm/v1/branch/brand/search", searchReqData.value),
			enabled: false, // 수동으로만 실행
		});

		// 검색 결과 감시자
		watch(
			() => searchData.data.value,
			(newData) => {
				if (newData && newData.page && newData.page.list) {
					// 검색 결과로 브랜드 목록 교체
					if (searchReqData.value.page === 1) {
						// 첫 페이지인 경우 결과 교체
						brandList.value = newData.page.list;
					} else {
						// 페이지 추가인 경우 결과 병합
						brandList.value = [...brandList.value, ...newData.page.list];
					}
					// 더보기 버튼 표시 여부
					hasMoreBrands.value = brandList.value.length < newData.page.total;
				} else {
					// 결과 없음
					brandList.value = [];
					hasMoreBrands.value = false;
				}
			}
		);

		function routerLink(brandUuid) {
			console.log(brandUuid);

			// 스크롤 위치 저장 (BI_002로 이동하기 전)
			const currentScroll = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
			sessionStorage.setItem("brandListScroll", currentScroll.toString());

			sessionStorage.setItem("brandUuid", brandUuid);
			// use named route with params so URL becomes /HFO_BI_002/<brandUuid>
			router.push({ name: 'HFO_BI_002', params: { brandUuid } });
		}

		// 이미지 관련 함수들 (유지)
		const makeBrandImageUrlFunction = (imagePath) => {
			return imagePath
				? process.env.VUE_APP_IMAGE_BASE_URL + "images/" + imagePath
				: DEFAULT_NO_IMAGE;
		};

		const handleBrandImageErrorFunction = (event) => {
			event.target.src = DEFAULT_NO_IMAGE;
		};

		const handleBannerHeroPcImageErrorFunction = (event) => {
			event.target.src = DEFAULT_NO_IMAGE;
		};

		return {
			tab,
			brandList,
			isTabActive,
			branchUuid,
			brandReqData,
			brandData,
			currentPage,
			pageSize,
			hasMoreBrands,
			routerLink,
			placeholderSearch,
			bannerPrList,
			bannerPrData,
			modules: [FreeMode, Pagination, Navigation, Autoplay],
			isBrandTab,
			searchReqData,
			searchData,
			isSearchMode,
			searchKeyword,
			brandNameInput,
			currentTabRef,
			selectedOptionsRef,
			// 이미지 관련 함수들 추가
			makeBrandImageUrl: makeBrandImageUrlFunction,
			handleBrandImageError: handleBrandImageErrorFunction,
			handleBannerHeroPcImageError: handleBannerHeroPcImageErrorFunction
		};
	},
	mounted() {
		// ① 스크롤 위치 복원
		const savedScroll = sessionStorage.getItem("brandListScroll");
		if (savedScroll) {
			this.savedScroll = parseInt(savedScroll, 10) || 0;
			sessionStorage.removeItem("brandListScroll");

			// nextTick으로 DOM 렌더링 완료 후 스크롤 복원
			this.$nextTick(() => {
				window.scrollTo(0, this.savedScroll);
			});
		}

		// ② 스크롤 이벤트 리스너 등록
		window.addEventListener("scroll", this.updateSavedScroll, { passive: true });

		// ③ 상태 복원을 nextTick에서 처리하여 탭 데이터가 준비된 후 실행
		this.$nextTick(() => {
			this.restoreSessionState();
		});
	},
	methods: {
		isAllCardStatusN(item) {
			const cardStatusKeys = ['hanaYn', 'bcYn', 'shYn', 'kbYn', 'nhYn', 'lotteYn', 'smYn', 'hdYn', 'weYn'];
			return cardStatusKeys.every((key) => String(item?.[key] || '').trim().toUpperCase() === 'N');
		},

		// 통합된 브랜드 검색/조회 메서드
		async performBrandSearch(options = {}) {
			const {
				keyword = this.brandNameInput?.trim() || '',
				resetPage = true,
				isLoadMore = false,
				resetSearchMode = false
			} = options;

			console.log('performBrandSearch 호출:', { keyword, resetPage, isLoadMore, resetSearchMode });

			// 검색 모드 초기화 (체크박스나 탭 변경 시)
			if (resetSearchMode) {
				this.isSearchMode = false;
				this.searchKeyword = "";
				this.brandNameInput = "";
			}

			// 페이지 초기화 (더보기가 아닌 경우)
			if (resetPage && !isLoadMore) {
				this.currentPage = 1;
				this.brandReqData.page = 1;
			}

			try {
				if (keyword && !resetSearchMode) {
					// 검색 모드: 검색 API 사용
					this.isSearchMode = true;
					this.searchKeyword = keyword;

					if (isLoadMore) {
						this.searchReqData.page += 1;
					} else {
						this.searchReqData.page = 1;
					}

					this.searchReqData.keyword = keyword;
					this.searchReqData.brandType = this.brandReqData.brandType;

					console.log('검색 API 호출:', this.searchReqData);
					await this.searchData.refetch();

				} else {
					// 일반 모드: 기존 브랜드 API 사용
					this.isSearchMode = false;
					this.searchKeyword = "";

					if (isLoadMore) {
						this.currentPage += 1;
						this.brandReqData.page = this.currentPage;
					}

					this.brandReqData.brandName = "";

					console.log('일반 API 호출:', this.brandReqData);
					await this.brandData.refetch();
				}

			} catch (error) {
				console.error('브랜드 검색/조회 실패:', error);
				this.brandList = [];
				this.hasMoreBrands = false;
			}
		},

		// 탭 선택 시 호출 - performBrandSearch 사용
		changeTab(tabIndex) {
			console.log('탭 변경 - performBrandSearch 호출', tabIndex);

			if (tabIndex >= 0 && tabIndex < this.tab.length && this.tab[tabIndex]) {
				this.currentTab = tabIndex;
				if (this.tab[tabIndex] && this.tab[tabIndex].cd) {
					this.brandReqData.brandServiceType = this.tab[tabIndex].cd;
				} else {
					this.brandReqData.brandServiceType = '';
				}

				// 선택한 탭 정보를 세션 스토리지에 저장
				sessionStorage.setItem("selectedCategoryTab", tabIndex.toString());
				sessionStorage.setItem("selectedServiceType", this.brandReqData.brandServiceType);

				// 통합 검색 함수 호출
				this.performBrandSearch({ resetPage: true, resetSearchMode: true });

			} else {
				console.warn('유효하지 않은 탭 인덱스:', tabIndex);
				this.currentTab = 0;
				this.brandReqData.brandServiceType = this.tab[0]?.cd || '';

				// 통합 검색 함수 호출
				this.performBrandSearch({ resetPage: true, resetSearchMode: true });
			}
		},

		// 체크박스 선택 시 호출 - performBrandSearch 사용
		handleOptionChange(event) {
			console.log('체크박스 변경 - performBrandSearch 호출', event.target.value);

			const selectedValue = event.target.value;
			this.selectedOptions = [selectedValue];

			// 브랜드 타입 설정
			switch (selectedValue) {
				case "1": // 전체
					this.brandReqData.brandType = "";
					break;
				case "2": // 온라인
					this.brandReqData.brandType = "BRAND_ONLINE";
					break;
				case "3": // 오프라인
					this.brandReqData.brandType = "BRAND_OFFLINE";
					break;
				default:
					this.brandReqData.brandType = "";
					this.selectedOptions = ["1"];
			}

			// 통합 검색 함수 호출
			this.performBrandSearch({ resetPage: true, resetSearchMode: true });
		},

		// 검색 버튼 클릭 시 호출 - performBrandSearch 사용
		search() {
			console.log('검색 버튼 클릭 - performBrandSearch 호출');
			this.performBrandSearch({ resetPage: true });
		},

		// 더보기 버튼 클릭 시 호출 - performBrandSearch 사용
		fetchMore() {
			console.log('더보기 버튼 클릭 - performBrandSearch 호출');
			this.performBrandSearch({ isLoadMore: true });
		},

		// 기존 함수들은 그대로 유지
		makeLinkUrl(linkUrl) {
			return linkUrl.startsWith("http") ? linkUrl : `http://${linkUrl}`;
		},

		updateBrandName() {
			// 입력만 저장하고 API는 호출하지 않음
			// 검색 버튼 클릭 또는 엔터키 입력 시 search() 메서드가 호출됨
		},

		updateSavedScroll() {
			this.savedScroll = window.scrollY;
		},

		// 세션 상태 복원 메서드 (탭 데이터가 준비된 후 호출)
		restoreSessionState() {
			const tabList = Array.isArray(this.tab) ? this.tab : [];
			console.log("세션 상태 복원 시작", { tabLength: tabList.length });

			// 저장된 탭과 서비스 타입 복원
			const selectedTab = sessionStorage.getItem("selectedCategoryTab");
			const selectedType = sessionStorage.getItem("selectedServiceType");

			if (selectedTab !== null) {
				const tabIndex = parseInt(selectedTab);
				console.log("복원할 탭 인덱스:", tabIndex);

				// 탭 인덱스가 유효한지 확인
				if (tabIndex >= 0 && tabIndex < tabList.length && tabList[tabIndex]) {
					this.currentTab = tabIndex;

					// Composition API의 ref와도 동기화
					if (this.currentTabRef) {
						this.currentTabRef.value = tabIndex;
					}

					// 해당 탭의 서비스 타입 코드 설정
					this.brandReqData.brandServiceType = tabList[tabIndex].cd || "";
					console.log("복원된 서비스 타입:", this.brandReqData.brandServiceType);

					// 세션 스토리지 업데이트 (현재 상태 저장)
					sessionStorage.setItem("selectedServiceType", this.brandReqData.brandServiceType);

				} else if (selectedType) {
					// 탭 인덱스가 유효하지 않지만 서비스 타입이 있는 경우
					console.log("탭 인덱스 무효, 서비스 타입으로 복원:", selectedType);
					this.brandReqData.brandServiceType = selectedType;

					// 서비스 타입으로 적절한 탭 찾기
					const matchingTabIndex = tabList.findIndex(t => t.cd === selectedType);
					if (matchingTabIndex >= 0) {
						this.currentTab = matchingTabIndex;
						if (this.currentTabRef) {
							this.currentTabRef.value = matchingTabIndex;
						}
					}
				} else {
					// 기본값으로 초기화
					this.currentTab = 0;
					this.brandReqData.brandServiceType = '';
				}

				// 데이터 조회 실행
				setTimeout(() => {
					this.performBrandSearch({ resetPage: true, resetSearchMode: false });
				}, 100); // 약간의 지연을 두어 모든 상태가 설정된 후 실행

			} else {
				// 세션 상태가 없는 경우 기본 상태로 데이터 로드
				console.log("세션 상태 없음 - 기본 데이터 로드");
				setTimeout(() => {
					this.performBrandSearch({ resetPage: true, resetSearchMode: true });
				}, 100);
			}

			// 저장된 검색어 복원
			const savedSearch = sessionStorage.getItem('brandNameInput');
			if (savedSearch) {
				this.brandNameInput = savedSearch;
				sessionStorage.removeItem('brandNameInput');

				// 검색 실행
				if (this.brandNameInput.trim()) {
					setTimeout(() => this.search(), 300);
				}
			}

			// 저장된 페이지 번호 복원
			const savedPage = sessionStorage.getItem('brandCurrentPage');
			if (savedPage) {
				this.currentPage = parseInt(savedPage);
				this.brandReqData.page = this.currentPage;
				sessionStorage.removeItem('brandCurrentPage');
			}

			// 저장된 필터 옵션 복원
			const savedOptions = sessionStorage.getItem('brandSelectedOptions');
			if (savedOptions) {
				try {
					this.selectedOptions = JSON.parse(savedOptions);
					sessionStorage.removeItem('brandSelectedOptions');

					// 필터 옵션에 따른 브랜드 타입 설정
					const selectedValue = this.selectedOptions[0];
					switch (selectedValue) {
						case "1": // 전체
							this.brandReqData.brandType = "";
							break;
						case "2": // 온라인
							this.brandReqData.brandType = "BRAND_ONLINE";
							break;
						case "3": // 오프라인
							this.brandReqData.brandType = "BRAND_OFFLINE";
							break;
						default:
							this.brandReqData.brandType = "";
							this.selectedOptions = ["1"];
					}
				} catch (error) {
					console.error("필터 옵션 복원 실패:", error);
					this.selectedOptions = ["1"];
				}
			}

			console.log("세션 상태 복원 완료", {
				currentTab: this.currentTab,
				brandServiceType: this.brandReqData.brandServiceType,
				brandType: this.brandReqData.brandType,
				selectedOptions: this.selectedOptions
			});
		},
	}
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/pages/bi_001.scss';
</style>
